import { printMoney, t } from '@process-creative/slate-theme-tools';

const processElements = () => {
  let totalComparePrice = 0;
  const flyoutItems = document.querySelectorAll('.rebuy-cart__flyout-item');
  

  flyoutItems.forEach((item: Element) => {
    const subtotalCompare = document.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');
    const htmlItem = item as HTMLElement;
    let customRetailWording = t('products.product.custom_retail_wording')
    let customPercentRaw = 0

    htmlItem.classList.forEach((className: string) => {
      const customRetailPercentageTag = className.match(/^tag-customretailpercentage_(\d+)$/);
      const customRetailWordingTag = className.match(/^tag-customretailwording_(.+)$/);

      if (customRetailWordingTag) {
        customRetailWording = String(customRetailWordingTag[1]).replace('-',' ').replace('_',' ');
      }
    
      if (customRetailPercentageTag) {
        customPercentRaw = Number(customRetailPercentageTag[1]);
      }
    });

    if (customPercentRaw > 0) {
      const rebuySelect = htmlItem.querySelector<HTMLSelectElement>('.rebuy-select');
      const subscriptionTexts = htmlItem.querySelectorAll('.rebuy-cart__flyout-item-subscription-text');
      const salePrice = htmlItem.querySelector('.rebuy-money.sale span:last-child');
      const comparePrice = htmlItem.querySelector('.rebuy-money.compare-at span:last-child');
      const salePriceRaw = Number(String(salePrice?.textContent).replace('$', '').replace('.', ''));
      
      const customRetailPercentageDivided = customPercentRaw / 100;
      const divisor = 1 - customRetailPercentageDivided;
      const comparePriceRetail = salePriceRaw / divisor;

      if (comparePrice) {
        comparePrice.innerHTML = `${printMoney(comparePriceRetail)}`;
      }

      subscriptionTexts.forEach((text: Element) => {
        text.innerHTML = `${t('products.product.custom_subscribe_save')} ${customPercentRaw}% ${customRetailWording}`;
      });

      if (rebuySelect) {
        rebuySelect.querySelectorAll('optgroup').forEach((group, i) => {
          if (group instanceof HTMLOptGroupElement && i === 1) {
            group.setAttribute('label', `${t('products.product.custom_subscribe_save')} ${customPercentRaw}% ${customRetailWording}`);
          }
        });
      }
    }
    
    

    // Select all .rebuy-money.compare-at elements
    const compareAtElement = item.querySelector<HTMLElement>('.rebuy-money.compare-at span:last-child');
    const quantityElement = item.querySelector<HTMLElement>('.rebuy-cart__flyout-item-quantity-widget-label-qty');
    
    let quantity = 1

    if (quantityElement) {
      quantity = Number(quantityElement.innerText)
    }

    if (quantity === 0) {
      quantity = 1
    }

    if (compareAtElement instanceof HTMLElement) {
      const comparePriceText = compareAtElement.textContent;
      if (comparePriceText) {
        // Remove the dollar sign and any decimals, then convert to number
        const comparePriceRaw = Number(comparePriceText.replace('$', '').replace('.', ''));
        const comparePlusQuant = comparePriceRaw * quantity
        // Accumulate the total compare price
        totalComparePrice += comparePlusQuant;
      }
    }
  });


  

  // Update the subtotal compare amount with the accumulated total
  const formattedTotalComparePrice = printMoney(totalComparePrice);
  const subtotalCompareElement = document.querySelectorAll('.rebuy-cart__flyout-subtotal-compare-amount');
  
  if (subtotalCompareElement) {
    subtotalCompareElement.forEach(subtotal => {
      subtotal.innerHTML = formattedTotalComparePrice;
    })
  }
};

// Listen for when the cart is ready
document.addEventListener('rebuy:cart.ready', () => {
  setTimeout(() => { processElements() }, 100);
});

// Listen for when an item is added to the cart
document.addEventListener('rebuy:cart.add', () => {
  setTimeout(() => { processElements() }, 100);
});

// Listen for when the cart changes (add, remove, quantity increase/decrease)
document.addEventListener('rebuy:cart.change', () => {
  setTimeout(() => { processElements() }, 100);
});

// Listen for when the cart is enriched with additional information (e.g., subscriptions)
document.addEventListener('rebuy:cart.enriched', () => {
  setTimeout(() => { processElements() }, 100);
});
